import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Fieldset from "../../../common/Fieldset";
import Row from "../../../common/Row";
import TextInput from "../../../common/TextInput";
import SelectInput from "../../../common/SelectInput";
import AutoComplete from "../../../common/AutoComplete";
import JaNeeRadioButtonGroup from "../../../common/JaNeeRadioButtonGroup";
import { Landen } from "../../../../constants/DomainConstants";
import { AUTOCOMPLETE_NO_RESULTS_CIJFERS } from "../../../../constants/ComponentConstants";

const ContactpersoonTijdensActiviteit = (props) => {
    const {
        model,
        getError,
        onChange,
        disabled,
        postcodes,
        gemeenten,
        landen,
        contactpersonen,
        hasStep4Status,
        validationMessageType
    } = props;

    const disableAllInputFields = disabled || model.id === "" || model.id === "00000000-0000-0000-0000-000000000000";

    const isBelgie = model.land === Landen.BELGIE;

    return <Fieldset title="Contactpersoon tijdens het evenement">
        <Row>
            <JaNeeRadioButtonGroup
                label="De contactpersoon tijdens het evenement is een andere contactpersoon"
                name={"andereContactpersoonTijdensActiviteit"}
                labelInside
                value={model.andereContactpersoonTijdensActiviteit}
                onChange={onChange}
                size={12}
                horizontal
                validationMessage={getError("andereContactpersoonTijdensActiviteit")}
                validationMessageType={validationMessageType}
                disabled={disabled || hasStep4Status}
            />
        </Row>
        {(!model.andereContactpersoonTijdensActiviteit || model.andereContactpersoonTijdensActiviteit === "false") ||
            <Fragment>
                <Row>
                    <SelectInput
                        size={6}
                        name="id"
                        label="Contactpersoon"
                        value={model.id}
                        onChange={onChange}
                        items={contactpersonen}
                        validationMessage={getError("id")}
                        validationMessageType={validationMessageType}
                        disabled={disabled}
                    />
                </Row>
                {model.id !== "newContact" ||
                    <Row>
                        <TextInput
                            size={6}
                            name="voornaam"
                            label="Voornaam"
                            value={model.voornaam}
                            onChange={onChange}
                            validationMessage={getError('voornaam')}
                            validationMessageType={validationMessageType}
                            disabled={disableAllInputFields}
                        />
                        <TextInput
                            size={6}
                            name="naam"
                            label="Naam"
                            value={model.naam}
                            onChange={onChange}
                            validationMessage={getError('naam')}
                            validationMessageType={validationMessageType}
                            disabled={disableAllInputFields}
                        />
                    </Row>}
                <Row>
                    <SelectInput
                        size={6}
                        name="land"
                        label="Land"
                        value={model.land}
                        onChange={onChange}
                        items={landen}
                        validationMessage={getError("land")}
                        validationMessageType={validationMessageType}
                        disabled={disableAllInputFields}
                        defaultItemVisible
                    />
                </Row>
                <Row>
                    <TextInput
                        name="straatEnHuisnummer"
                        label="Straat en huisnummer"
                        value={model.straatEnHuisnummer}
                        onChange={onChange}
                        validationMessage={getError('straatEnHuisnummer')}
                        validationMessageType={validationMessageType}
                        disabled={disableAllInputFields}
                    />
                </Row>
                {isBelgie ?
                    <Row>
                        <AutoComplete
                            size={3}
                            label="Postcode"
                            name="postcodeBE"
                            value={model.postcodeBE}
                            onChange={onChange}
                            validationMessage={getError("postcodeBE")}
                            validationMessageType={validationMessageType}
                            items={postcodes}
                            noResultsMessage={AUTOCOMPLETE_NO_RESULTS_CIJFERS}
                            disabled={disableAllInputFields}
                        />
                        <AutoComplete
                            size={9}
                            label="Gemeente"
                            name="gemeenteBE"
                            value={model.gemeenteBE}
                            onChange={onChange}
                            validationMessage={getError("gemeenteBE")}
                            validationMessageType={validationMessageType}
                            items={gemeenten}
                            disabled={disableAllInputFields}
                        />
                    </Row>
                    :
                    <Row>
                        <TextInput
                            name="postcode"
                            label="Postcode"
                            size={3}
                            onChange={onChange}
                            disabled={disableAllInputFields}
                            value={model.postcode}
                            validationMessage={getError('postcode')}
                            validationMessageType={validationMessageType} />
                        <TextInput
                            name="gemeente"
                            label="Gemeente"
                            size={9}
                            onChange={onChange}
                            disabled={disableAllInputFields}
                            value={model.gemeente}
                            validationMessage={getError('gemeente')}
                            validationMessageType={validationMessageType} />
                    </Row>
                }
                <Row>
                    <TextInput
                        size={6}
                        name="email"
                        label="E-mail"
                        value={model.email}
                        onChange={onChange}
                        validationMessage={getError('email')}
                        validationMessageType={validationMessageType}
                        disabled={disableAllInputFields}
                    />
                    <TextInput
                        size={6}
                        name="telefoon"
                        label="Telefoon/GSM"
                        value={model.telefoon}
                        onChange={onChange}
                        validationMessage={getError('telefoon')}
                        validationMessageType={validationMessageType}
                        disabled={disableAllInputFields}
                    />
                </Row>
            </Fragment>
        }
    </Fieldset>;
};

ContactpersoonTijdensActiviteit.propTypes = {
    model: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    getError: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    postcodes: PropTypes.array.isRequired,
    gemeenten: PropTypes.array.isRequired,
    landen: PropTypes.array.isRequired,
    contactpersonen: PropTypes.array.isRequired,
    hasStep4Status: PropTypes.bool.isRequired,
    validationMessageType: PropTypes.string
};

export default ContactpersoonTijdensActiviteit;